<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button" class="active">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <!-- 新增內容 ↓ -->
          <!-- 標題 -->
          <div class="bg-box">
            <h1>優惠專區</h1>
          </div>
          <!-- 文字框 -->
          <div class="bg-box text_notice" v-if="MemberCouponData && MemberCouponData.CouponMsg">
            <p v-for="(line, index) in MemberCouponData.CouponMsg.split('\n')" :key="index">
              {{ line }}
            </p>
          </div>
          <hr>
          <!-- 頁籤按鈕 -->
          <div class="bg-box">
            <ul class="tabs_box">
              <li><button class="btn_tab" :class="status == 1 ? 'active' : ''" @click="status = 1">全部</button></li>
              <li><button class="btn_tab" :class="status == 2 ? 'active' : ''" @click="status = 2">未使用</button></li>
              <li><button class="btn_tab" :class="status == 3 ? 'active' : ''" @click="status = 3">已使用</button></li>
              <li><button class="btn_tab" :class="status == 4 ? 'active' : ''" @click="status = 4">已失效</button></li>
              <li><button class="btn_tab" :class="status == 5 ? 'active' : ''" @click="status = 5">即將到期</button></li>
            </ul>
          </div>
          <hr>
          <!-- 頁籤內容 -->
          <div class="tab_main show">
            <template v-for="CouponList in CouponLists">
              <div class="bg-box">
                <ul class="list">
                  <li :class="CouponList.Status == 3 || CouponList.Status == 4 ? 'none' : ''">
                    <div class="img_box">
                      <img v-if="CouponList.Coupon.Image" :src="MemberCouponData.SiteUrl + CouponList.Coupon.Image"
                        alt=""></img>
                      <img v-else src="img/coupon_logo.svg" alt="">
                      <p v-if="CouponList.Status == 3" class="used">已使用</p>
                      <p v-if="CouponList.Status == 4" class="used">已過期</p>
                      <p v-if="CouponList.Status == 5" class="expiring">即將到期</p>
                    </div>
                    <div class="text">
                      <h2>{{ CouponList.Coupon.Title }}</h2>
                      <p v-if="CouponList.Coupon.CouponContent">{{ CouponList.Coupon.CouponContent }}</p>
                      <template v-if="CouponList.Coupon.Note">
                        <p v-for="(line, index) in CouponList.Coupon.Note.split('\n')" :key="'note-' + index" class="time">{{ line.replace('\r', '') }}</p>
                      </template>
                      <p v-if="!CouponList.Coupon.StartTime && !CouponList.Coupon.EndTime && !CouponList.LimitTime" class="time">無使用期限</p>
                      <p v-if="CouponList.Coupon.StartTime && !CouponList.Coupon.EndTime" class="time">使用期限：{{
                        timeString(CouponList.Coupon.StartTime, "YYYY/MM/DD HH:mm") }} 起</p>
                      <p v-if="!CouponList.Coupon.StartTime && CouponList.Coupon.EndTime" class="time">使用期限：{{
                        timeString(CouponList.Coupon.EndTime, "YYYY/MM/DD HH:mm") }} 截止</p>
                      <p v-if="CouponList.Coupon.StartTime && CouponList.Coupon.EndTime" class="time">使用期限：{{
                        timeString(CouponList.Coupon.StartTime, "YYYY/MM/DD HH:mm") }} 到 {{
                          timeString(CouponList.Coupon.EndTime, "YYYY/MM/DD HH:mm") }}</p>
                      <p v-if="CouponList.LimitTime">
                        使用期限：{{ timeString(CouponList.LimitTime, "YYYY/MM/DD HH:mm") }}
                      </p>
                      <p class="time">可使用次數: {{ CouponList.Time }}</p>
                    </div>
                    <div class="btn_box">
                      <p
                        v-if="CouponList.Coupon.CouponType == 1 || (CouponList.Coupon.CouponType == 2 && CouponList.Coupon.LinkType != 3)">
                        優惠券代碼：<span class="textToCopy">{{ CouponList.Code }}</span></p>
                      <p v-else>
                      </p>
                      <p v-if="CouponList.Coupon.CouponType == 3"></p>
                      <div v-if="CouponList.Status == 2">
                        <template v-if="CouponList.Coupon.CouponType == 1">
                          <button class="btn_coupon" v-clipboard:copy="CouponList.Code" v-clipboard:success="onCopy"
                            v-clipboard:error="onError">複製</button>
                        </template>
                        <template v-if="CouponList.Coupon.CouponType == 2">
                          <div>
                            <template v-if="CouponList.Coupon.LinkType != 3">
                              <button class="btn_coupon" v-clipboard:copy="CouponList.Code" v-clipboard:success="onCopy"
                                v-clipboard:error="onError">複製</button>
                              <button v-if="CouponList.Coupon.LinkType == 1" class="btn_coupon"
                                @click="gotoPost(CouponList.Coupon.PId)">使用說明</button>
                              <button v-if="CouponList.Coupon.LinkType == 2" class="btn_coupon"
                                @click="gotoUrl(CouponList.Coupon.Link)">使用說明</button>
                            </template>
                            <template v-else>
                              <button class="btn_coupon" @click="showQRCode(CouponList.Code)"
                                style="width: 120px;">顯示QRCode</button>
                            </template>
                          </div>
                        </template>
                        <template v-if="CouponList.Coupon.CouponType == 3">
                          <router-link :to="{ name: 'MemberCouponMain', params: { CPLId: CouponList.CPLId } }"
                            class="btn_coupon" tag="button">
                            使用
                          </router-link>
                        </template>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <hr>
            </template>
          </div>
          <section class="page" v-if="pageAll > 1">
            <div class="container">
              <paginate :no-li-surround="false" :page-count="pageAll" :page-range="5" :margin-pages="1"
                :click-handler="loadList" :prev-text="'<'" :next-text="'>'" :prev-link-class="'Prev'"
                :next-link-class="'next'" :container-class="''" :page-link-class="''" :active-class="'page-active'"
                :hide-prev-next="false">
              </paginate>
            </div>
          </section>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>

    <!-- QR Code Modal -->
    <div v-if="showQRCodeModal" class="qrcode-modal-overlay" @click="closeQRCodeModal">
      <div class="qrcode-modal-content" @click.stop>
        <div class="qrcode-modal-header">
          <h3>優惠券 QR Code</h3>
          <button class="qrcode-modal-close" @click="closeQRCodeModal">&times;</button>
        </div>
        <div class="qrcode-modal-body">
          <qrcode :value="currentQRCodeValue" :size="280" level="H"></qrcode>
        </div>
        <div class="qrcode-modal-footer">
          <button class="btn-confirm" @click="closeQRCodeModal">確定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Paginate from "vuejs-paginate";
import Storage from "@/utils/storage.js";
import { tempdir } from "shelljs";
import VueClipboard from "vue-clipboard2";
import QRCode from "qrcode.vue";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.component("paginate", Paginate);
Vue.use(VueClipboard);

// this.$t("立即購買")
const messages = {
  zh_tw: {
  },
  en: {
  },
  jp: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MemberCoupon",
  i18n,
  components: {
    qrcode: QRCode
  },
  data() {
    return {
      MemberCouponData: null,
      CouponLists: [],
      pageAll: 0,
      perPage: 3,
      local: "zh_tw",
      status: 1,
      IsTester: false,
      hasInvite: false,
      showQRCodeModal: false,
      currentQRCodeValue: '',
    };
  },
  watch: {
    status: function (val) {
      this.status = val;
      this.loadList(1);
    },
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/MemberCoupon",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得優惠卷過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.MemberCouponData = JSON.parse(res.data);
          that.IsTester = that.MemberCouponData.IsTester;
          that.hasInvite = that.MemberCouponData.hasInvite;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    this.loadList(1);
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member_coupon");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/_MemberCoupon",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          page: page,
          perPage: this.perPage,
          status: that.status,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.CouponLists = res.CouponLists;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            window.pageYOffset = 0;
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
      });
    },
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    gotoUrl(Link) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          Link,
          "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        window.open(Link, "_blank");
      }
    },
    gotoPost(PId) {
      const routeData = this.$router.resolve({
        name: "Post",
        params: { PId: PId }
      });
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          routeData.href,
          "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        window.open(routeData.href, "_blank");
      }
    },
    onCopy(e) {
      this.$swal({
        heightAuto: false,
        title: this.$t("複製成功"),
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: this.$t("確定"),
      });
    },
    onError(e) {
      alert(this.$t("序號複製失敗, 請稍後再試一次"));
    },
    showQRCode(code) {
      this.currentQRCodeValue = code;
      this.showQRCodeModal = true;
    },
    closeQRCodeModal() {
      this.showQRCodeModal = false;
      this.currentQRCodeValue = '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qrcode-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.qrcode-modal-content {
  background: white;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.qrcode-modal-header {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qrcode-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.qrcode-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.2s;
}

.qrcode-modal-close:hover {
  color: #4b5563;
}

.qrcode-modal-body {
  padding: 30px 20px;
  text-align: center;
}

.qrcode-modal-body canvas {
  margin: 0 auto;
  display: block;
}

.qrcode-value {
  margin-top: 15px;
  font-size: 14px;
  color: #6b7280;
  word-break: break-all;
}

.qrcode-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e5e7eb;
  text-align: center;
}

.btn-confirm {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-confirm:hover {
  background-color: #2563eb;
}

.btn-confirm:active {
  background-color: #1d4ed8;
}
</style>



// WEBPACK FOOTER //
// src/components/MemberCoupon.vue